// extracted by mini-css-extract-plugin
export default {"input":"AddMarkForm_input__yhBjo","del":"AddMarkForm_del__NJTmE"};